module.exports = __webpack_public_path__ + "img/b8.925125a4.jpg";